import { Link, LinkProps } from "react-router-dom";
import { useIsOpening } from "src/core/hooks/useIsOpening";
import { OpeningSpinner } from "./OpeningSpinner";

type Props = LinkProps;

export const ButtonLink = ({ children, ...props }: Props) => {
    const opening = useIsOpening(props.to);

    return (
        <Link {...props} className={["btn", props.className].join(" ")}>
            {opening && <OpeningSpinner className="loading-xs" />}

            {children}
        </Link>
    );
};
